module.exports = __webpack_public_path__ + "img/cmacgm.525a055e.png";